module.exports = __webpack_public_path__ + "77366554cbe210550a89dcd04242e3ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/6_0.jpg
// module id = 524
// module chunks = 0